var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-list-item',{attrs:{"three-line":""}},[_c('v-list-item-content',[_c('p',{staticClass:"display-1 text--primary"},[_vm._v(" "+_vm._s(_vm.$t('menu.prerecords'))+" ")])])],1),_c('pre-records-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }